import { atom } from 'jotai';

export const isExistNotReadNotificationAtom = atom<boolean>(false);
